import { render } from "./ServTypeServ.vue?vue&type=template&id=0934fe03"
import script from "./ServTypeServ.vue?vue&type=script&lang=js"
export * from "./ServTypeServ.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__